import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_URL = `${BACKEND_URL}/api`;

const api = axios.create({
  baseURL: API_URL,
  // The preview gateway terminates CORS with a wildcard origin. Authentication
  // therefore travels through the explicit Bearer token interceptor below.
  withCredentials: false,
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("fundle_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401 && !window.location.pathname.startsWith("/login")) {
      localStorage.removeItem("fundle_token");
      localStorage.removeItem("fundle_user");
      const portal = localStorage.getItem("fundle_portal") || "enterprise";
      window.location.href = portal === "store" ? "/store/login" : portal === "crm" ? "/crm/login" : "/enterprise/login";
    }
    return Promise.reject(err);
  }
);

export default api;
